module.exports = __webpack_public_path__ + "static/placeholder2-9bf041b97007a487bed9fb8d62eaac70.jpg";